import { render, staticRenderFns } from "./BlockManualPanelBuilder.vue?vue&type=template&id=765f7520&scoped=true"
import script from "./BlockManualPanelBuilder.vue?vue&type=script&lang=js"
export * from "./BlockManualPanelBuilder.vue?vue&type=script&lang=js"
import style0 from "./BlockManualPanelBuilder.vue?vue&type=style&index=0&id=765f7520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f7520",
  null
  
)

export default component.exports